exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../../../../node_modules/css-loader/index.js!vue-directive-tooltip/css/index.css"), "");

// module
exports.push([module.id, ".sub-attachment[data-v-9c2e770a] {\n  position: relative;\n  padding: 1.5em 0;\n}\n.sub-attachment .remove-item[data-v-9c2e770a] {\n  position: absolute;\n  top: 0.5em;\n  right: 0;\n  color: #999;\n}\n.sub-attachment .info-wrap[data-v-9c2e770a] {\n  padding-left: 1em;\n}\n.sub-attachment .pill[data-v-9c2e770a] {\n  margin: 1em 0 2em;\n}\n.sub-attachment .qty-edit span[data-v-9c2e770a] {\n  padding-right: 1em;\n}\n", ""]);

// exports
